import { Box, Flex } from '@chakra-ui/react';
import { Routes, Route, Navigate } from 'react-router-dom';

import PrivateContentLayout from '../Common/PrivateContentLayout';
import TutorSideBar from '../Components/TutorSideBar';
import TutorCalendar from '../Tutor/TutorCalendar';
import TutorBatches from '../Tutor/TutorBatches';
import TutorUpcomingClasses from '../Tutor/TutorUpcomingClasses';
import LessonSummaryViewer from '../Tutor/LessonSummaryViewer';
import TutorExams from '../Tutor/TutorExams';
import EvaluateExamByTutor from '../Tutor/EvaluateExamByTutor';

const TutorRouter = () => {


    return (
        <Box >

          {/* Sidebar with fixed width */}
            <TutorSideBar />
            <PrivateContentLayout>
          {/* Main content area with flexible width */}
          <Box overflowY="auto">
            <Routes>
              <Route path="/" element={<Navigate to="tutor-calendar" />} />
              <Route path="tutor-calendar" element={<TutorCalendar />} />
              <Route path="tutor-batches" element={<TutorBatches />} />
              <Route path="tutor-upcoming-classes" element={<TutorUpcomingClasses />} />
              <Route path="tutor-upcoming-classes/lesson-summary/:plannedClassId" element={<LessonSummaryViewer />} />
              <Route path="tutor-exams" element={<TutorExams />} />
              <Route path="tutor-exams/evaluate-exam-by-tutor/:exam_id" element={<EvaluateExamByTutor />} />
            </Routes>
          </Box>
          </PrivateContentLayout>
      </Box>
    );
  };

export default TutorRouter;
